import React from 'react';

/**
 * PaginationDots Component
 * Shows current position in the walkthrough
 */
const PaginationDots = ({ total, current }) => {
  return (
    <div className="pagination-dots" role="navigation" aria-label="Walkthrough progress">
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className={`pagination-dot ${index === current ? 'active' : ''}`}
          aria-label={`Step ${index + 1} of ${total}`}
          aria-current={index === current ? 'step' : undefined}
        />
      ))}
    </div>
  );
};

export default PaginationDots;
